import { Box, styled } from '@mui/material';

import { DividingLineStyle } from '@components/EducationCard/UniversityCard/UniversityInfo/UneversityInfo.types';
import { JobDescriptionContainerStyle } from './JobDescription.types';

export const JobDescriptionContainer = styled('div')(
  ({ shadow }: JobDescriptionContainerStyle) => ({
    width: '600px',
    height: '1100px',
    padding: '24px',

    display: 'flex',
    flexDirection: 'column',
    rowGap: '24px',

    boxShadow: `1px 1px 8px 1px ${shadow}`,
    borderRadius: '6px',

    boxSizing: 'border-box',
    overflow: 'hidden',

    '@media screen and (min-width: 2120px)': {
      width: '800px',
    },

    '@media screen and (max-width: 1280px)': {
      width: '100%',
      maxWidth: '600px',
      height: '850px',
    },
  }),
);

export const JobCommonContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',

  boxSizing: 'border-box',
}));

export const JobDescContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  rowGap: '12px',

  boxSizing: 'border-box',
}));

export const DividingLine = styled(Box)(
  ({ borderColor }: DividingLineStyle) => ({
    width: '100%',

    borderTop: `2px solid ${borderColor}`,
  }),
);
